import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import LoginView from "../views/LoginView.vue";
import ScheduleView from "../views/ScheduleView.vue";
import LogoutView from "../views/LogoutView.vue";
import CompaniesView from "../views/CompaniesView.vue";
import CitiesView from "../views/CitiesView.vue";
import BranchesView from "../views/BranchesView.vue";
import AdminUsersView from "../views/AdminUsersView.vue";
import AnalysisView from "../views/AnalysisView.vue";
import CompanySettingsView from "../views/CompanySettingsView.vue";
import SecurityOfficersView from "../views/SecurityOfficersView.vue";
import ChangePassword from "../views/ChangePassword.vue"
import SitesView from "../views/SitesView.vue"
import SiteScheduleView from "../views/SiteScheduleView.vue"
import JobCallsView from "../views/JobCallsView.vue"
import ExpiryDatesScanView from "../views/ExpiryDatesScanView.vue"
import PaysView from "../views/PaysView.vue"
import UpdatePayRatesView from "../views/UpdatePayRatesView.vue"
import SecurityOfficerLoginsView from "../views/SecurityOfficerLoginsView.vue"
import BanOfficerForSiteView from "../views/BanOfficerForSiteView.vue"
import BanOfficerForClientView from "../views/BanOfficerForClientView.vue"
import HolidayRequestsView from "../views/HolidayRequestsView.vue"
import EventsView from "../views/EventsView.vue"
import OfficerGroupsView from "../views/OfficerGroupsView.vue"
import OfficerGroupMembersView from "../views/OfficerGroupMembersView.vue"



const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login"  // This redirects root to /login
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/schedule",
    name: "schedule",
    component: ScheduleView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/jobCalls",
    name: "jobCalls",
    component: JobCallsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/siteSchedule",
    name: "siteSchedule",
    component: SiteScheduleView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },

  },
  {
    path: "/securityOfficers",
    name: "securityOfficers",
    component: SecurityOfficersView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path:"/changepassword",
    name:"changepassword",
    component: ChangePassword,
    props:{baseUrl: localStorage.getItem("baseUrl"), userId:11},
    //props:{baseUrl: "https://localhost:44325/", userId:11},
    //props:{baseUrl: "https://emergingsols2.somee.com/", userId:0},
  },
  {
    path:"/sites",
    name:"sites",
    component:SitesView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/companies",
    name:"companies",
    component:CompaniesView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},  
  },
  {
    path:"/cities",
    name:"cities",
    component:CitiesView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/branches",
    name:"branches",
    component:BranchesView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/adminUsers",
    name:"adminUsers",
    component:AdminUsersView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/analysis",
    name:"analysis",
    component:AnalysisView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/companySettings",
    name:"companySettings",
    component:CompanySettingsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/expiryDatesScan",
    name:"expiryDatesScan",
    component:ExpiryDatesScanView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},  
  },
  {
    path:"/pays",
    name:"pays",
    component:PaysView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},
  },
  {
    path:"/updatePayRates",
    name:"updatePayRates",
    component:UpdatePayRatesView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/securityOfficerLogins",
    name:"securityOfficerLogins",
    component:SecurityOfficerLoginsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/banOfficerForSite",
    name:"banOfficerForSite",
    component:BanOfficerForSiteView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/banOfficerForClient",
    name:"banOfficerForClient",
    component:BanOfficerForClientView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/holidayRequests",
    name:"holidayRequests",
    component:HolidayRequestsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/events",
    name:"events",
    component:EventsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/officerGroups",
    name:"officerGroups",
    component:OfficerGroupsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/officerGroups/:groupId",
    name:"officerGroupMembers",
    component:OfficerGroupMembersView,
    props: (route) => ({ baseUrl: localStorage.getItem("baseUrl"), groupId: Number(route.params.groupId) }),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
